export enum Actions {
  SET_USER_DATA = '@USER/SET_USER_DATA',
  SET_WALLET_DATA = '@USER/SET_WALLET_DATA',
  SET_USER_LINKREF = '@USER/SET_USER_LINKREF',
  SET_PHONE_NUMBER = '@USER/SET_PHONE_NUMBER',
  SET_USER_BALANCE = '@USER/SET_USER_BALANCE',
  SET_PERSONAL_DATA = '@USER/SET_PERSONAL_DATA',
  SET_NFT_OWNERSHIP = '@USER/SET_NFT_OWNERSHIP'
}
